import { ReactNode } from 'react';
import { IconButton as MuiIconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const IconButton = ({
  onClick,
  className,
  children,
  mode = 'light',
  'aria-label': ariaLabel,
}: {
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  children: ReactNode;
  mode?: 'light' | 'dark';
  'aria-label'?: string;
}) => {
  return (
    <StyledIconButton
      onClick={onClick}
      mode={mode}
      aria-label={ariaLabel}
      className={className}
    >
      {children}
    </StyledIconButton>
  );
};

const StyledIconButton = styled(MuiIconButton)<{
  mode: 'light' | 'dark';
}>(({ theme, mode }) => ({
  path: {
    stroke:
      mode === 'light'
        ? theme.palette.textPrimaryBlack
        : theme.palette.white,
  },

  '& .MuiTouchRipple-root': {
    color:
      mode === 'light'
        ? theme.palette.primary.main
        : theme.palette.white,
  },
}));

export default IconButton;
